import axios from 'axios';
const url = 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/';
// const url = 'http://0.0.0.0:3000/dev';
export default axios.create({
	baseURL: url,
});
